import type { Graph, Profile, Profiles } from '@shared/model/api';

const BASE = `${import.meta.env.BASE_URL.replace(/\/$/, '')}/api/v1`;

async function getJson<T>(path: string): Promise<T> {
    const response = await fetch(`${BASE}${path}`, {
        headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`${path}: HTTP ${response.status}`);
    return (await response.json()) as T;
}

export function fetchGraph(): Promise<Graph> {
    return getJson<Graph>('/graph.json');
}

export function fetchAllProfiles(): Promise<Profiles> {
    return getJson<Profiles>('/profiles.json');
}

export function fetchProfile(routeId: string): Promise<Profile> {
    return getJson<Profile>(`/routes/${encodeURIComponent(routeId)}/profile.json`);
}
